import { useEffect, useState } from "react";
import gsap from "gsap";

const CustomCursor = () => {
  useEffect(() => {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".cursor-follower");
    const gimg = document.querySelectorAll(".gimg");

    let posX = 0,
      posY = 0,
      mouseX = 0,
      mouseY = 0;

    let nextForceFollower = false, lastHovered = false;

    const updateCursor = () => {
      posX += (mouseX - posX) / 9;
      posY += (mouseY - posY) / 9;

      let followerOffset = lastHovered ? 30 : 20;

      gsap.set(follower, {
        left: posX - followerOffset,
        top: posY - followerOffset,
      });
      gsap.set(cursor, {
        left: mouseX - 5,
        top: mouseY - 5,
      });

      requestAnimationFrame(updateCursor); // Request next frame for smoother animation
    };

    const handleMouseMove = (e: MouseEvent) => {
      mouseX = e.pageX;
      mouseY = e.pageY;

      if(nextForceFollower) {
        nextForceFollower = false;

        posX = mouseX;
        posY = mouseY;
      }

      // Check hovered
      {
        let detectedHover = false;

        const eventElem = e.target;
        if(eventElem instanceof HTMLElement) {
          if(eventElem.computedStyleMap().get('cursor') == 'pointer')
            detectedHover = true;
        }

        if(detectedHover != lastHovered) {
          lastHovered = detectedHover;
          
          if(detectedHover)
            follower?.classList.add('hovered');
          else
            follower?.classList.remove('hovered');
        }
      }
    };

    const handleIFrameEnter = () => {
      lastHovered = false;
      follower?.classList.remove('hovered');

      if(cursor)
        (cursor as HTMLElement).style.display = 'none';

      if(follower)
        (follower as HTMLElement).style.display = 'none';
    };

    const handleIFrameLeave = () => {
      if(cursor)
        (cursor as HTMLElement).style.display = '';
      
      if(follower)
        (follower as HTMLElement).style.display = '';

      nextForceFollower = true;
    };

    // Adding mouse move listener
    document.addEventListener("mousemove", handleMouseMove);

    // Hover effect on gimg elements
    const handleMouseEnter = () => {
      cursor?.classList.add("active");
      follower?.classList.add("active");
    };

    const handleMouseLeave = () => {
      cursor?.classList.remove("active");
      follower?.classList.remove("active");
    };

    gimg.forEach((el) => {
      el.addEventListener("mouseenter", handleMouseEnter);
      el.addEventListener("mouseleave", handleMouseLeave);
    });

    // Start the animation loop
    requestAnimationFrame(updateCursor);

    // Listen iframe enter & leave
    document.querySelectorAll('iframe').forEach(iframe => {
      iframe.addEventListener('mouseenter', () => handleIFrameEnter());
      iframe.addEventListener('mouseleave', () => handleIFrameLeave());
    });

    // Cleanup
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      gimg.forEach((el) => {
        el.removeEventListener("mouseenter", handleMouseEnter);
        el.removeEventListener("mouseleave", handleMouseLeave);
      });
    };
  }, []);

  return (
    <div className="relative z-10">
      <div className="cursor" />
      <div className="cursor-follower" />
    </div>
  );
};

export default CustomCursor;
